/**
 * Logs only when NODE_ENV === "development".
 * Do not pass passwords, tokens, OTPs, or other secrets — redact or omit even here.
 */
export function devLog(...args) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.log(...args);
  }
}

export function devWarn(...args) {
  if (process.env.NODE_ENV === "development") {
    // eslint-disable-next-line no-console
    console.warn(...args);
  }
}
